"use client"
import { selectorOptions, usePathname, useRouter } from "@opensea/navigation"
import { Item, ItemContent, ItemTitle } from "@opensea/next-ui-kit"
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalHeaderTitle,
} from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { useShallow } from "zustand/react/shallow"
import { trackAction } from "@/lib/integrations/datadog"
import { useLanguageModalStore } from "@/stores/use-language-modal-store"

export function LanguageModal() {
  const router = useRouter()
  const pathname = usePathname()
  const t = useTranslations("LanguageModal")

  const { modalOpen, setModalOpen } = useLanguageModalStore(
    useShallow(state => ({
      modalOpen: state.modalOpen,
      setModalOpen: state.setModalOpen,
    })),
  )

  return (
    <Modal
      content={
        <>
          <ModalHeader>
            <ModalHeaderTitle>{t("title")}</ModalHeaderTitle>
          </ModalHeader>
          <ModalBody>
            {selectorOptions.map(option => {
              return (
                <Item
                  className="rounded border-none focus-visible:outline-hidden"
                  key={option.label}
                  onClick={() => {
                    void trackAction("switch language", {
                      value: option.locale,
                    })
                    router.replace(pathname, {
                      locale: option.locale,
                    })
                  }}
                >
                  <ItemContent>
                    <ItemTitle>{option.label}</ItemTitle>
                  </ItemContent>
                </Item>
              )
            })}
          </ModalBody>
        </>
      }
      onOpenChange={setModalOpen}
      open={modalOpen}
    />
  )
}
